import { InfoCircleIcon } from "../../icons";

const DetailRow = ({ label, value, showInfo = false, valueContent }) => (
  <div className="flex items-center justify-between gap-3 border-b border-divider p-4 last:border-b-0">
    <div className="flex min-w-0 items-center gap-1">
      <p className="whitespace-nowrap text-sm font-normal leading-[19.5px] text-text-primary">
        {label}
      </p>
      {showInfo && <InfoCircleIcon className="shrink-0 text-[#555] dark:text-[#FAFAFA]" />}
    </div>
    {valueContent ?? (
      <p className="max-w-[58%] shrink-0 text-right text-sm font-medium leading-[19.5px] text-text-primary">
        {value}
      </p>
    )}
  </div>
);

export default DetailRow;
